import { useTranslations } from "use-intl";

import { useAppDateTime } from "@/hooks/use-app-date-time";
import type { FeaturePageRenderModel } from "@garimpa/api/featurePages/types";

export function FeaturePageByline({ page }: { page: FeaturePageRenderModel["page"] }) {
  const { longDate } = useAppDateTime();
  const t = useTranslations("globals.featurePages");

  return (
    <div className="border-y border-border/60 bg-background/80 px-4 py-4 text-sm text-muted-foreground">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center">
        <span className="font-semibold text-foreground">{t("editorialByline")}</span>
        <span aria-hidden="true">·</span>
        <time dateTime={page.publishedAt}>
          {t("publishedOn", { date: longDate(page.publishedAt) })}
        </time>
        <span aria-hidden="true">·</span>
        <time dateTime={page.updatedAt}>{t("updatedOn", { date: longDate(page.updatedAt) })}</time>
      </div>
    </div>
  );
}
